<div class="pessoa-form-container">
<p-toolbar styleClass="mb-4">
    <div class="p-toolbar-group-left">
        <h5>{{ tituloPagina }}</h5>
    </div>

    <div class="p-toolbar-group-right">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="cancel()" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </div>
</p-toolbar>

<p-tabView>
    <div class="form-scroll-container">
        <div [ngStyle]="{'margin': '7px'}">
            <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12" formGroupName="pessoa">
                <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                <label class="form-check-label" for="ativo">Ativo</label>
            </div>

            <div class="field col-12 md:col-12 xl:col-9" formGroupName="pessoa">
                <p-floatlabel>
                    <input type="text" id="nome" pInputText formControlName="nome">
                    <label for="nome">Nome</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-3" formGroupName="pessoa">
                <p-floatlabel>
                    <p-dropdown inputId="tipo" [options]="dropDownTipoPessoa" formControlName="tipo">
                    </p-dropdown>
                    <label for="tipo">Tipo da pessoa</label>
                </p-floatlabel>
            </div>

            <div *ngIf="form.get('pessoa.tipo').value == 0" class="field col-12 md:col-12 xl:col-3"
                formGroupName="pessoa_fisica">

                <label for="nascimento">Data de nascimento</label>
                <input type="date" formControlName="nascimento" pInputText>


            </div>

            <div *ngIf="form.get('pessoa.tipo').value == 0" class="field col-12 md:col-12 xl:col-3 pdt"
                formGroupName="pessoa_fisica">
                <p-floatlabel>
                    <p-dropdown inputId="sexo" [options]="dropDownSexo" formControlName="sexo">
                    </p-dropdown>
                    <label for="sexo">Sexo</label>
                </p-floatlabel>

            </div>

            <div *ngIf="form.get('pessoa.tipo').value == 0" class="field col-12 md:col-12 xl:col-3 pdt"
                formGroupName="pessoa_fisica">
                <p-floatlabel>
                    <p-inputMask inputId="cpf" mask="999.999.999-99" formControlName="cpf"></p-inputMask>
                    <label for="cpf">CPF</label>

                </p-floatlabel>
                <!-- <small id="cpf-help" *ngIf="form.get('pessoa_fisica.cpf').invalid" class="p-error">CPF é
                    obrigatório.</small> -->
            </div>







            <div *ngIf="form.get('pessoa.tipo').value == 1" class="field col-12 md:col-12 xl:col-6"
                formGroupName="pessoa_juridica">
                <p-floatlabel>
                    <input type="text" id="razao_social" pInputText formControlName="razao_social">
                    <label for="razao_social">Razão Social</label>
                </p-floatlabel>

            </div>

            <div *ngIf="form.get('pessoa.tipo').value == 1" class="field col-12 md:col-12 xl:col-6"
                formGroupName="pessoa_juridica">
                <p-floatlabel>
                    <p-inputMask inputId="cnpj" mask="99.999.999/9999-99" formControlName="cnpj">
                    </p-inputMask>
                    <label for="cnpj">CNPJ</label>
                </p-floatlabel>

            </div>

            <div class="field col-12 md:col-12 xl:col-12" formGroupName="pessoa">
                <p-floatlabel>
                    <textarea rows="5" cols="30" pTextarea formControlName="observacao"></textarea>

                    <label for="observacao">Observação</label>
                </p-floatlabel>

            </div>











        </form>


    <h6>Contato </h6>
    <br>

    <form [formGroup]="form" class="p-fluid grid ">
        <div class="field col-12 md:col-4 xl:col-4" formGroupName="pessoa">
            <p-floatlabel>
                <p-inputMask formControlName="celular_principal" mask="(99) 99999-9999">
                </p-inputMask>
                <label for="celular1">Celular</label>
            </p-floatlabel>
            <!-- <small id="email-help"
                *ngIf="form.get('pessoa.celular_principal').value == null || form.get('pessoa.celular_principal').value == '' || form.get('pessoa.celular_principal').value == ' '"
                class="p-error">Celular
                é obrigatório.</small> -->
        </div>
        <div class="field col-12 md:col-4 xl:col-4" formGroupName="pessoa">
            <p-floatlabel>
                <p-inputMask formControlName="telefone_principal" mask="(99) 9999-9999">
                </p-inputMask>
                <label for="celular2">Telefone </label>
            </p-floatlabel>
        </div>
        <div class="field col-12 md:col-4 xl:col-4" formGroupName="pessoa">
            <p-floatlabel>
                <input type="text" id="email_principal" pInputText formControlName="email_principal">
                <label for="email_principal">E-mail</label>
            </p-floatlabel>
        </div>
    </form>

    <h6>Endereços </h6>
    <br>
    <form [formGroup]="form" class="p-fluid grid ">
        <div class="field col-12 md:col-12 xl:col-3" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <p-inputMask inputId="cep" mask="99999-999" formControlName="cep"></p-inputMask>
                <label for="cep">CEP</label>
            </p-floatlabel>
        </div>

        <div class="col-12 md:col-12 xl:col-2">
            <button *ngIf="processando == false" pButton pRipple icon="pi pi-search" (click)="getCEP()" label="Buscar"
                type="button" class="p-button-raised p-text-bold btn-lg"></button>
            <p-progressSpinner *ngIf="processando" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
                strokeWidth="8" fill="#EEEEEE" animationDuration=".5s">
            </p-progressSpinner>
        </div>

        <div class="field col-12 md:col-12 xl:col-4" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <input type="text" id="logradouro" pInputText formControlName="logradouro" [disabled]="processando">
                <label for="logradouro">Logradouro</label>
            </p-floatlabel>
        </div>
        <div class="field col-12 md:col-12 xl:col-3" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <input type="text" id="bairro" pInputText formControlName="bairro" [disabled]="processando">
                <label for="bairro">Bairro</label>
            </p-floatlabel>
        </div>

        <div class="field col-12 md:col-12 xl:col-2" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <input type="text" id="numero" pInputText formControlName="numero" [disabled]="processando">
                <label for="numero">Numero</label>
            </p-floatlabel>
        </div>

        <div class="field col-12 md:col-12 xl:col-3" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <input type="text" id="complemento" pInputText formControlName="complemento" [disabled]="processando">
                <label for="complemento">Complemento</label>
            </p-floatlabel>
        </div>


        <div class="field col-12 md:col-12 xl:col-3" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <input type="text" id="municipio" pInputText formControlName="municipio" [disabled]="processando">
                <label for="municipio">Municipio</label>
            </p-floatlabel>
        </div>

        <div class="field col-12 md:col-12 xl:col-2" formGroupName="pessoa_endereco">
            <p-floatlabel>
                <input type="text" id="uf" pInputText formControlName="uf" [disabled]="processando">
                <label for="uf">UF</label>
            </p-floatlabel>
        </div>






        <div class="col-12 md:col-12 xl:col-2">
            <button pButton pRipple icon="pi pi-plus" (click)="addEndereco()" label="Inserir" type="button"
                class="p-button-raised p-text-bold btn-lg"></button>
        </div>


    </form>

    <p-table [value]="array_enderecos" [columns]="cols_endereco" dataKey="id" [rows]="rows"
        styleClass="p-datatable-responsive-demo p-datatable-gridlines" [rowHover]="true">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="background-color: #efefef;" *ngFor="let col of columns">
                    {{col.header}}
                </th>
                <th style="background-color: #efefef; width: 10%; text-align: center;">
                    Remover
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td style="background-color: aliceblue;" *ngFor="let col of columns">
                    <span class="p-column-title">{{col.header}}</span>
                    {{rowData[col.field]}}
                </td>
                <td style="background-color: aliceblue; text-align: center;">
                    <button pButton pRipple icon="pi pi-trash" pTooltip="Remover Endereço"
                        class="p-button-rounded p-button-danger" (click)="removeEndereco(rowData)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>


    <br>
    </div>
    </div>
</p-tabView>
</div>

<p-dialog [(visible)]="tela_nova_pessoa" [style]="{width: '1000px'}" header="Pessoa" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-fluid   ">
            <div [ngStyle]="{'margin': '7px'}">
                <form [formGroup]="form" class="p-fluid grid ">
                    <div class="field col-12 md:col-12 xl:col-7" formGroupName="nova_pessoa">
                        <p-floatlabel>
                            <input type="text" id="nome" pInputText formControlName="nome">
                            <label for="nome">Nome</label>
                        </p-floatlabel>
                    </div>
                    <div class="field col-12 md:col-12 xl:col-2" formGroupName="nova_pessoa">
                        <p-floatlabel>
                            <p-inputMask formControlName="celular" mask="(99) 99999-9999">
                            </p-inputMask>
                            <label for="celular1">Celular</label>
                        </p-floatlabel>
                    </div>
                    <div class="field col-12 md:col-12 xl:col-3">
                        <p-floatlabel>
                            <input type="text" id="email" pInputText formControlName="email">
                            <label for="email">E-mail</label>
                        </p-floatlabel>
                    </div>


                </form>
            </div>

        </div>


    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Voltar" icon="pi pi-times" class="p-button-danger"
            (click)="tela_nova_pessoa = false"></button>
        <button pButton pRipple label="Salvar" icon="pi pi-check" (click)="saveNovaPessoa()"
            class="p-button-success"></button>
    </ng-template>
</p-dialog>
